module.exports = __webpack_public_path__ + "media/react/gre/adaptive_prep_v1/assets/segment_1-27f38f12bb1ed10e0080fb3e6881d196.svg";